import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
  duration: 1000,       // Duration of animations
  offset: 120,          // Offset (in pixels) from the original trigger point
  delay: 0,             // Delay before the animation starts
  once: true,           // Whether the animation should happen only once - while scrolling down
  mirror: false,        // Whether elements should animate out while scrolling past them
  disable: false,       // This ensures animations are enabled on all devices, including mobile
});

  

ReactDOM.render(<App />, document.getElementById('root'));